
export function isObject(val: any): val is object {
  return val.constructor === Object
}
